class MediaCanvas extends HTMLElement {
  #controller = new AbortController();

  constructor() {
    super();
    this.sectionId = null;
    this.unsubscribe = null;
    this.activeRequest = null;
    this.inputsState = {}; // 👈 kalıcı state
    this.onVariantChange = this.#handleVariantUpdate.bind(this);
  }

  connectedCallback() {
    const {signal} = this.#controller;
    this.sectionId = this.dataset.section;
    this.unsubscribe = subscribe(
      PUB_SUB_EVENTS.variantChange,
      this.onVariantChange,
    );

    const target = this.closest('.shopify-section, form, product-form');
    const imageObject = this.dataset.bg ? JSON.parse(this.dataset.bg) : null;
    const canvasObject = this.dataset.canvas
      ? JSON.parse(this.dataset.canvas)
      : null;

    console.log('imageObject', imageObject);
    console.log('canvasObject', canvasObject);

    if (imageObject || canvasObject) {
      const canvas = this.querySelector('#dynamicCanvas');
      if (!canvas || !(canvas instanceof HTMLCanvasElement)) return;

      const context = canvas.getContext('2d');
      if (!context) return;

      const image = new Image();

      const updateCanvas = () => {
        const scale = Math.min(
          canvas.width / image.width,
          canvas.height / image.height,
        );
        const x = canvas.width / 2 - (image.width / 2) * scale;
        const y = canvas.height / 2 - (image.height / 2) * scale;

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(
          image,
          x,
          y,
          image.width * scale,
          image.height * scale,
        );

        // Textleri çiz
        if (canvasObject) {
          Object.entries(canvasObject).forEach(([key, field]) => {
            const inputEl = document.querySelector(`#canvas-${key}`);
            if (!inputEl || !(inputEl instanceof HTMLInputElement)) return;
            const textValue = inputEl.value || '';

            field.positions.forEach((pos) => {
              let fontSize = pos.fontSize;
              const maxAllowedWidth =
                typeof pos.maxWidth === 'number'
                  ? pos.maxWidth
                  : canvas.width - 20;

              const hasOffset =
                typeof pos.positionX === 'number' && !Number.isNaN(pos.positionX);
              const anchorX = (canvas.width / 2) + (hasOffset ? pos.positionX : 0);
              const textAlign = pos.textAlign || 'center';

              context.fillStyle = pos.fontColor || '#000';
              context.textBaseline = 'top';
              context.textAlign = textAlign;

              let textWidth;
              do {
                context.font = `${fontSize}px ${pos.fontFamily}`;
                textWidth = context.measureText(textValue).width;
                if (textWidth > maxAllowedWidth) fontSize -= 1;
              } while (textWidth > maxAllowedWidth && fontSize > 8);

              let clipStartX;
              if (textAlign === 'center') {
                clipStartX = anchorX - maxAllowedWidth / 2;
              } else if (textAlign === 'right') {
                clipStartX = anchorX - maxAllowedWidth;
              } else {
                clipStartX = anchorX;
              }

              if (textWidth > maxAllowedWidth) {
                context.save();
                context.beginPath();
                context.rect(
                  clipStartX,
                  pos.positionY,
                  maxAllowedWidth,
                  fontSize * 1.4,
                );
                context.clip();
                context.fillText(textValue, anchorX, pos.positionY);
                context.restore();
                return;
              }

              context.fillText(textValue, anchorX, pos.positionY);
            });
          });
        }
      };

      image.onload = function () {
        updateCanvas();

        // Input eventleri
        if (canvasObject) {
          Object.keys(canvasObject).forEach((key) => {
            const inputEl = document.querySelector(`#canvas-${key}`);
            if (inputEl && inputEl instanceof HTMLInputElement) {
              ['input', 'keyup', 'change'].forEach((evt) =>
                inputEl.addEventListener(evt, updateCanvas, {signal}),
              );
            }
          });
        }
      };

      image.src = imageObject || '';

      console.log('image.src', image.src);
    }
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #handleVariantUpdate(event) {
    console.log('Variant changed', event.data);
    const canvasDOM = event.data.html.querySelector('media-canvas');
    if (!canvasDOM) return;

    this.replaceWith(canvasDOM);
  }
}

if (!customElements.get('media-canvas')) {
  customElements.define('media-canvas', MediaCanvas);
}
